module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pstats"
  }, [_c('div', {
    staticClass: "pstats-itens"
  }, [_c('div', [_vm._v("\n      Tipo: "), _c('span', [_vm._v(_vm._s(_vm.HelperTipo(_vm.leilao.tipo)))])]), _vm._v(" "), _c('div', [_vm._v("\n      Lote Anterior: "), _c('span', [_vm._v(_vm._s(_vm.loteAnterior))])]), _vm._v(" "), _c('div', [_vm._v("\n      Lotes: "), _c('span', [_vm._v(_vm._s(_vm._f("number")((_vm.pregao !== null ? _vm.pregao.totalLotes : 0))))])]), _vm._v(" "), _c('div', {
    staticClass: "leilao-aberto"
  }, [_vm._v("\n      Status do Leilão:\n      "), (!_vm.isPregaoAtivo) ? _c('span', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['f4']),
      expression: "['f4']"
    }],
    attrs: {
      "title": "Clique para abrir"
    },
    on: {
      "shortkey": _vm.abrirPregao,
      "click": _vm.abrirPregao
    }
  }, [_vm._v("Fechado "), _c('i', {
    staticClass: "shoutcut"
  }, [_vm._v("F4 para abrir")])]) : _c('span', {
    staticClass: "aberto"
  }, [_vm._v("Aberto ")])])]), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pstats-buttons"
  }, [_c('a', {
    staticClass: "server-monitor",
    attrs: {
      "title": "Monitorar Servidor"
    }
  }, [_vm._v("Monitor")]), _vm._v(" "), _c('a', {
    staticClass: "streaming",
    attrs: {
      "title": "Vídeo ao vivo"
    }
  }, [_vm._v("Streaming")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-147a9fc7","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/website/pregao/components/Stats.vue
// module id = 712
// module chunks = 2